<template>
    <v-card class="elevation-10">
        <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="amcs.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)">{{ props.item.name }}</td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.amcs.detail', params : { id : props.item.id } }"><v-icon left>edit</v-icon>Edit</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="amcs.data">
            <v-pagination
                    v-model="page"
                    :length="amcs.meta.last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ amcs.meta.from }} to {{ amcs.meta.to }} of {{ amcs.meta.total }} entries</p>
        </div>
    </v-card>
</template>

<script>
    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                amcs: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                states: [],
                countries: [],
                state_id: '',
                country_id: '',
                sortBy: 'name',
                order: 'asc',
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getAmcs();
            this.debouncedGetAmcs = _.debounce(this.getAmcs, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetAmcs();
            },
            last_page: function () {
                if (this.page > this.amcs.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getAmcs();
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Laboratories list.'
                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteLaboratorio', {
                            id: id
                        }).then((res) => {
                            this.getAmcs();
                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getAmcs();
            },
            getAmcs () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    }
                };
                this.$store.dispatch('getLaboratorios', params).then((res) => {

                    this.amcs = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            ver(id, blank) {
                if (blank) {
                    let route = this.$router.resolve({ name: 'admin.amcs.detail', params : { id : id } });
                    window.open(route.href, '_blank');
                } else {
                    this.$router.push({ name: 'admin.amcs.detail', params : { id : id } });
                }

            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/ListComponent.vue